"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _user = require("@/api/iot/user");
var _setmeal = require("@/api/iot/setmeal");
var _default = {
  props: ['editItem'],
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      formData: {
        uids: [],
        coupon_id: 0,
        coupon_num: 1,
        merchant_id: '',
        name: '',
        amount: 0,
        min_amount: 0,
        expire_day: 0,
        receive_type: 1
      },
      memberList: [],
      defaultMemberList: [
        // { id: 0, mobile: '全部' },
      ],
      rules: {
        uids: [{
          required: true,
          message: '请选择发放用户',
          trigger: 'change'
        }],
        coupon_num: [{
          required: true,
          message: '请输入优惠券数量',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '优惠券数量必须大于0',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return '发放优惠券';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.getSelectMemberList();
        this.$nextTick(function () {
          if (_this.editItem) {
            _this.formData.coupon_id = _this.editItem.id;
            delete _this.formData.id;
            for (var key in _this.formData) {
              if (_this.editItem[key]) {
                _this.formData[key] = _this.editItem[key];
              }
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    reset: function reset() {
      this.formData = this.$options.data().formData;
      this.$refs['form'].resetFields();
    },
    remoteMethod: function remoteMethod() {
      var _this2 = this;
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.$func.debounce(function () {
        console.log('remoteMethod', query);
        if (query === '') {
          _this2.memberList = (0, _toConsumableArray2.default)(_this2.defaultMemberList);
        } else {
          _this2.loading = true;
          _this2.getSelectMemberList(query);
        }
      });
    },
    getSelectMemberList: function () {
      var _getSelectMemberList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search,
          param,
          res,
          _this$defaultMemberLi,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                search = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                param = {
                  search: search,
                  merchant_id: this.editItem.merchant_id
                };
                _context.next = 4;
                return (0, _user.getSelectMemberList)(param).catch(function () {});
              case 4:
                res = _context.sent;
                // console.log('getSelectMemberList', res)
                this.loading = false;
                if (res.data) {
                  if (search == '') {
                    (_this$defaultMemberLi = this.defaultMemberList).push.apply(_this$defaultMemberLi, (0, _toConsumableArray2.default)(res.data));
                    this.memberList = (0, _toConsumableArray2.default)(this.defaultMemberList);
                  } else {
                    this.memberList = (0, _toConsumableArray2.default)(res.data);
                  }
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getSelectMemberList() {
        return _getSelectMemberList2.apply(this, arguments);
      }
      return getSelectMemberList;
    }(),
    chkUids: function chkUids() {
      if (this.formData.uids.indexOf(0) > -1) {
        this.formData.uids = [0];
      }
    },
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this3 = this;
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$refs['form'].validate().catch(function (err) {});
              case 2:
                valid = _context2.sent;
                if (!valid) {
                  _context2.next = 7;
                  break;
                }
                (0, _setmeal.sendCoupon)({
                  form_data: this.formData
                }).then(function (res) {
                  _this3.dialogVisible = false;
                  _this3.$emit('getList');
                });
                _context2.next = 9;
                break;
              case 7:
                this.$message({
                  message: '请检查表单错误',
                  type: 'error'
                });
                return _context2.abrupt("return", false);
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};
exports.default = _default;